import { Component, OnDestroy, OnInit } from '@angular/core';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MapService } from '../../../commons/map.service';
import { FourDService } from '4d-mapper';
import { XsApplicationEventsService } from '@src/app/xs/services/events/application-events.service';
import { XsEventListenerInterface } from '@src/app/xs/interfaces/event-listener.interface';
import { XsIdentityInterface } from '@src/app/xs/interfaces/identify.interface';
import { BaseComponent } from '@src/app/commons/BaseComponent';
import { MatSnackBar, MatDialog } from '@angular/material';
import { Router } from '@angular/router';

export const navTools = Object.freeze({
  DEFAULT     : 0,
  FIRST       : 1,
  SECOND      : 2,
  THIRD       : 3
});

@Component({
  selector: 'app-nav-toolbar',
  templateUrl: './nav-toolbar.component.html',
  styleUrls: ['./nav-toolbar.component.scss']
})
export class NavToolbarComponent extends BaseComponent implements OnInit, OnDestroy {

  // currently selected tool
  selectedTool: any = false;

  // our list of tools / modes / states
  tools:any[] = [] ;

  viewer:any = null;

  constructor ( 
    public router: Router, public snackBar: MatSnackBar, public dialog: MatDialog,
    public mapService: MapService, public fourD: FourDService, public applicationEvents: XsApplicationEventsService
  ) { 
    super(router, snackBar, dialog);
  }

  ___mapViewer ( incoming:any ) {
    this.viewer = incoming.viewer;
    console.log('****** incoming',incoming);
    let me = this;
    setTimeout( () => { me.setMode( navTools.DEFAULT ); }, 500 );
  }

  ngOnInit() {

    /* this is where we set up and define our tools (in order) */
    this.tools.push({ id: navTools.FIRST, icon: 'mouse-pointer' });
    this.tools.push({ id:navTools.SECOND, icon: 'keyboard' });
    this.tools.push({ id:navTools.THIRD, icon: 'key' });
  }

  /* select and unselect tools */
  selectTool(item) {
    if ( this.selectedTool == item ) {
      this.unselectTool();
      return;
    }
    this.selectedTool = item;
    this.setMode ( item.id );
  }
  
  unselectTool() {
    console.log ( 'inspect.component :: unselectTool()');
    this.selectedTool = false;
    this.setMode ( navTools.DEFAULT );
  }
  
  setMode ( toolId:number ) {

    console.log('****** setMode', toolId, this.viewer );
    let scene = this.viewer['scene'];

    if ( scene ) {

      switch ( toolId ) {

        case navTools.FIRST:
          // insert cesium tweaks here
          
          scene.screenSpaceCameraController.enableLook = false;

          console.log ( 'nav-toolbar::setMode FIRST');
          break;

        case navTools.SECOND:
          // insert cesium tweaks here
          
          scene.screenSpaceCameraController.enableTilt = false;

          console.log ( 'nav-toolbar::setMode SECOND');
          break;

        case navTools.THIRD:
          // insert cesium tweaks here
          
          scene.screenSpaceCameraController.enableZoom = false;

          console.log ( 'nav-toolbar::setMode THIRD');
          break;

        default:
          // insert default cesium tweaks here  

          scene.screenSpaceCameraController.enableTilt = true;
          scene.screenSpaceCameraController.enableZoom = true;
          scene.screenSpaceCameraController.enableZoom = true;

          console.log ( 'nav-toolbar::setMode DEFAULT');
      }
    }
  }

}
